import create from "zustand";
// import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

let store: any = (set: any) => ({
  guest: {},
  setGuest: (guest: any) => {
    set((state: any) => {
      state.guest = guest;
    });
  },
});

// store = devtools(store);
store = immer(store);

const useAuth = create(store);

export { useAuth };
